var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemMomentFilledDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#222324",
  d: "M8 17a1 1 0 0 0 1-1v-5.586l2.293 2.293a1 1 0 0 0 1.414 0L15 10.414V16a1 1 0 1 0 2 0V8a.999.999 0 0 0-1.707-.707L12 10.586 8.707 7.293A1.001 1.001 0 0 0 7 8v8a1 1 0 0 0 1 1"
}))));
export default SvgGemMomentFilledDark;